module.exports = __webpack_public_path__ + "nc.svg?b4ec991217b164f4e2c94995c1465d63";